import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import history from 'src/history';
import { getUser } from 'src/libraries/auth.library';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useAdminContext } from 'src/contexts/admin.context';
import { IAdminRole } from 'src/models/admin.model';
import Lang from 'src/libraries/language';
import { getAdminStatus } from 'src/selectors/admin.selector';
import { actionTypes } from 'src/ducks/admin.duck';
import style from '../role-maintenance-list/role-maintenance-list.module.scss';

type IProp = {
  data: IAdminRole;
};

const RoleMaintenanceDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useAdminContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getAdminStatus(state, actionTypes.ADMIN_DATA_DELETE);

  const handleDelete = useCallback(async () => {
    if (data.empNo) {
      const user = getUser();
      const response = await actions.dataDELETE(data.empNo);

      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_ADMIN_SUCCESS_DELETE,
            `${data.lastName}, ${data.firstName}`
          )
        );

        if (user?.emp_no === data.empNo) {
          history.replace('/');
          window.location.reload();
        } else {
          setIsDeleteOpen(false);
          actions.listGET();
        }
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_ADMIN_DELETE}
      content={
        <div className={style.content}>
          {Lang.formatString(
            Lang.MSG_CONFIRM_DELETE,
            `${data.lastName}, ${data.firstName}`
          )}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default RoleMaintenanceDelete;
